import { render, staticRenderFns } from "./appointmentmanager.vue?vue&type=template&id=9747754a&scoped=true"
import script from "./appointmentmanager.vue?vue&type=script&lang=js"
export * from "./appointmentmanager.vue?vue&type=script&lang=js"
import style0 from "./appointmentmanager.vue?vue&type=style&index=0&id=9747754a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9747754a",
  null
  
)

export default component.exports